import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { PaymentGateway as PaymentGatewayType } from '../../../services/paymentsGatewayGet';
import { PaymentsGatewayState } from '../../../store/paymentsGateway/types';
import { AppState } from '../../../store/store';
import styles from './NewPaymentMethodSelector.module.scss';

interface Props {
  paymentsGatewayState: PaymentsGatewayState;
  selectedMethod: PaymentGatewayType | null;
  onSelectMethod: (method: PaymentGatewayType) => void;
}

const NewPaymentMethodSelector = ({ paymentsGatewayState, selectedMethod, onSelectMethod }: Props) => {
  const [methods, setMethods] = useState<PaymentGatewayType[]>([]);

  useEffect(() => {
    if (paymentsGatewayState.status === 'loaded') {
      setMethods(paymentsGatewayState.payload.paymentsGateway);
    }
  }, [paymentsGatewayState]);

  return (
    <div className={styles.paymentMethodSelector}>
      <label className={styles.label}>Método de pago</label>
      <div className={styles.methods}>
        {methods.map((method) => {
          const isSelected = selectedMethod && selectedMethod.code === method.code;
          return (
            <div
              key={method.code}
              className={`${styles.method} ${isSelected ? styles.selected : ''}`}
              onClick={() => onSelectMethod(method)}
            >
              <div className={styles.icon}>
                <img src={method.urlImage} alt={method.name} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
              </div>
              <div className={styles.details}>
                <div className={styles.name}>{method.name}</div>
                <div className={styles.description}>{method.paymentMethod}</div>
              </div>
              <div className={`${styles.radio} ${isSelected ? styles.selected : ''}`}>
                {isSelected && <div className={styles.dot}></div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  paymentsGatewayState: state.paymentsGateway,
});

export default connect(mapStateToProps)(NewPaymentMethodSelector);
